module.exports = __webpack_public_path__ + "img/79.5.COD.d5c0bb37.png";